/**
 * @fileoverview Initializes date input fields.
 */

import { err, ok, type Result, unwrapOr } from "@nx-paeonia/utils-result";

import flatpickr from "flatpickr";

const elements = document.querySelectorAll(".input-date");

if (elements.length === 0) {
	throw new Error("No input date elements found");
}

const getDataFromElement = <R>(element: HTMLInputElement, dataKey: string): Result<R, null> => {
	const dataValue = element.dataset[dataKey];
	if (dataValue === undefined) {
		return err(null);
	}

	try {
		return ok<R>(JSON.parse(dataValue));
	} catch {
		return err(null);
	}
};

for (const element of Array.from(elements)) {
	if (!(element instanceof HTMLInputElement)) {
		throw new TypeError("Element is not an input element");
	}

	if (element.dataset.native !== undefined) {
		continue;
	}

	const dateFormat = unwrapOr(getDataFromElement<string>(element, "format"), "F j, Y");

	const defaultConfig = {
		dateFormat,
		defaultDate: element.value || undefined,
		enableTime: element.classList.contains("input-date--time"),
		time_24hr: true,
		noCalendar: element.classList.contains("input-date--time"),
		static: false,
		positionElement: element.closest(".order-form"),
		appendTo: element.closest(".order-form"),
		onReady: () => {
			// Ensure the input is a text input to allow flatpickr to function correctly
			element.type = "text";
		},
	};

	// @ts-expect-error - Assuming flatpickr is globally available
	flatpickr(element, defaultConfig);
}
